import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Query } from 'react-apollo';

import { ALL_PUBLISHED_POSTS_BY_CATEGORY, ALL_PUBLISHED_POSTS_BY_AUTHOR_ID } from '../../graphql/queries';
import SearchInput from '../../common/components/SearchInput';
import Pagination from '../Pagination';
import { StyledSearch } from './search.styled';


const Search = ({ author, category }) => {
  const [searchString, setSearchString] = useState('');

  const handleChange = useCallback(e => {
    setSearchString(e.target.value);
  }, []);

  const getResultsAmount = data => {
    if (author) {
      return _.get(data, 'allPublishedPostsByAuthorId[0].amount', 0);
    }

    if (category) {
      return _.get(data, 'allPublishedPostsByCategory[0].amount', 0);
    }
  };

  return (
    <StyledSearch>

      <Query
        query={author ? ALL_PUBLISHED_POSTS_BY_AUTHOR_ID : category ? ALL_PUBLISHED_POSTS_BY_CATEGORY : null}
        variables={{ sortBy: 'publish_date', order: 'DESC', limit: 8, from: 0, author_id: author && author.user_id, category }}
      >
        {
          ({ loading, error, data, refetch }) => {
            return (
              <>
                <SearchInput
                  value={searchString}
                  handleChange={handleChange}
                  handleReset={e => {
                    e.preventDefault();

                    setSearchString('');

                    refetch({ sortBy: 'publish_date', order: 'DESC', limit: 8, from: 0, author_id: author && author.user_id, category, searchString: undefined });
                  }}
                  handleSubmit={e => {
                    e.preventDefault();

                    refetch({ searchString, sortBy: 'publish_date', order: 'DESC', limit: 8, from: 0, author_id: author && author.user_id, category });
                  }}
                />
                {author && <h1>News by {author.user_name} {author.user_surname}</h1>}
                {category && <h1>{category} News</h1>}
                <h1>{`Results (${getResultsAmount(data)})`}</h1>
                <Pagination
                  posts={data ? (data.allPublishedPostsByAuthorId || data.allPublishedPostsByCategory) : []}
                  handlePagination={() => refetch({ author_id: author && author.user_id, category, sortBy: 'publish_date', order: 'DESC', limit: (data.allPublishedPostsByAuthorId || data.allPublishedPostsByCategory).length * 2, from: 0 })}
                  className="post-layout_grid-item"
                  loading={loading}
                />
              </>
            );
          }
        }
      </Query>
    </StyledSearch>
  );
};

Search.propTypes = {
  author: PropTypes.shape({ user_id: PropTypes.string, user_name: PropTypes.string, user_surname: PropTypes.string }),
  category: PropTypes.string
};

Search.defaultProps = {
  posts: []
};

export default Search;
